import {otsBaseApi} from "../../ots-api";
import {Settlement, SettlementSearchCriteria} from "../../../model/settlement";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ['Settlements', 'ActivityPeriodSettlements']})

const settlementApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchSettlements: builder.query<
      Settlement[],
      SettlementSearchCriteria
    >({
      query: (criteria) => ({
        url: '/settlements/search',
        method: 'POST',
        body: criteria,
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(
              ({id}) => ({type: 'Settlements', id} as const)
            ),
            {type: 'Settlements', id: 'LIST'},
          ];
        } else {
          return [{type: 'Settlements', id: 'LIST'}];
        }
      },
    }),
    getAllSettlements: builder.query<Settlement[], string | undefined>({
      query: (regionId) => ({
        url: `/settlements/all`,
        method: 'GET',
        params: regionId ? {regionId: regionId} : undefined
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: 'Settlements', id} as const)),
            {type: 'Settlements', id: 'LIST'},
          ];
        } else {
          return [{type: 'Settlements', id: 'LIST'}];
        }
      },
    }),
    getSettlementsByActivityPeriod: builder.query<
      Settlement[], string
    >({
      query: (arg) => ({
        url: `/settlements/activity-period/${arg}`,
        method: 'GET',
      }),
      providesTags: (result, _error, arg, _meta) => {
        if (result) {
          return [
            ...result.map(
              ({id}) => ({type: "Settlements", id} as const)
            ),
            {type: "ActivityPeriodSettlements", id: arg}
          ];
        } else {
          return [];
        }
      },
    }),
    getSettlement: builder.query<Settlement, string>({
      query: (id) => ({
        url: `/settlements/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{type: 'Settlements', id}],
    }),
    createSettlement: builder.mutation<Settlement, Partial<Settlement>>({
      query: (settlement) => ({
        url: '/settlements',
        method: 'POST',
        body: settlement,
      }),
      invalidatesTags: [{type: 'Settlements', id: 'LIST'}],
    }),
    updateSettlement: builder.mutation<Settlement, Partial<Settlement>>({
      query: (settlement) => ({
        url: '/settlements',
        method: 'PUT',
        body: settlement,
      }),
      invalidatesTags: (result, error, {id}) => [{type: 'Settlements', id}],
    }),
    deleteSettlement: builder.mutation<void, Partial<Settlement>>({
      query: (settlement) => ({
        url: '/settlements',
        method: 'DELETE',
        body: settlement,
      }),
      invalidatesTags: (result, error, {id}) => [{type: 'Settlements', id}],
    }),
  }),
})

export const {
  useSearchSettlementsQuery,
  useGetAllSettlementsQuery,
  useGetSettlementsByActivityPeriodQuery,
  useGetSettlementQuery,
  useCreateSettlementMutation,
  useUpdateSettlementMutation,
  useDeleteSettlementMutation,
} = settlementApi;
